import React, { Fragment, useMemo } from "react";
import Editor from "../Editor/Editor";
import List, { ListPropsType } from "./List";

import list from "../../utils/array/list";

const WorkPhaseList = React.forwardRef<any, Partial<ListPropsType & { [key: string]: any }>>((props, ref) => {
    const header = useMemo(() => {
        return (_props) => {
            return list(props.disabledActions).indexOf("create") === -1 ? <Editor
                {..._props}
                children={null}
                actions={props.actions}
                exists={props.exists}
                valuesParser={props.valuesParser}
                onSaved={() => {
                    if (!props.value) {
                        _props.setState({ ..._props.state });
                    }
                }}
            /> : null
        }
    }, [list(props.disabledActions).join(","), props.actions, props.exists, props.valuesParser, JSON.stringify(props.value)]);
    const formatter = useMemo(() => {
        return (_props) => {
            return <>
                <Editor
                    {..._props}
                    {...{ [_props.config.idfield]: _props?.data?.[_props.config.idfield] }}
                    actions={props.actions}
                    exists={props.exists}
                    valuesParser={props.valuesParser}
                    onSaved={() => {
                        if (!props.value) {
                            _props.setState({ ..._props.state });
                        }
                    }}
                    onRemoved={() => {
                        if (!props.value) {
                            _props.setState({ ..._props.state });
                        }
                    }}
                    values={_props.data}
                    children={null}
                />
            </>;
        }
    }, [props.actions, props.exists, props.valuesParser, JSON.stringify(props.value)]);
    const labelFormatter = useMemo(() => {
        return (_props) => {
            return _props?.value?.label;
        }
    }, []);
    return <Fragment>
        <List
            ref={ref}
            component="WorkPhase"
            filter={props.filter}
            view={["id"]}
            fields={{
                "actions": {
                    header,
                    filterable: false,
                    sortable: false,
                    width: 1,
                    formatter
                },
                "colleague": {
                    filterable: false,
                    sortable: false,
                    width: 1,
                    formatter: labelFormatter,
                },
                "work_phase": {
                    filterable: false,
                    sortable: false,
                    width: 1,
                    formatter: labelFormatter,
                },
            }}
            {...props}
        />
    </Fragment>;
});

export default WorkPhaseList;